import React, { memo } from 'react'

import Category from './Category'

import style from './Guides.module.scss'

const Guides = ({ guides, showAll = false, title }) => (
  <>
    { title && <h1 className={style.title}>{ title }</h1>}
    <div className={style.grid} data-show-all={showAll}>
      { guides.map((category) => (
        <Category 
          key={category.id} 
          category={category} />
      ))}
    </div>
  </>
)

export default memo(Guides)